var _defs, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipConnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Design",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5a03ee;fill-rule:evenodd;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.28,22.1c-4.52-4.6-11.9-4.67-16.49-.16-4.59,4.51-4.65,11.89-.14,16.49,4.51,4.6,11.9,4.67,16.49.16,4.59-4.51,4.65-11.89.14-16.49Zm-5.61,13.03c-1.68.97-3.84.94-5.5-.06-3.28-1.98-3.64-6.3-1.11-8.79,2.19-2.15,5.71-2.12,7.87.08,2.49,2.54,2.06,6.86-1.26,8.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.88,47.03c5.11,5.2,5.04,13.55-.16,18.65-5.2,5.1-13.55,5.02-18.66-.18-5.11-5.2-5.04-13.55.16-18.66,5.19-5.1,13.55-5.02,18.65.18"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.2 38.64 31 62.6 28.14 59.81 52.33 35.85 55.2 38.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipConnectIcon);
export default __webpack_public_path__ + "static/media/HIP Connect Icon.a7396ee70ef3c1248017fbc7e04659cc.svg";
export { ForwardRef as ReactComponent };